/**
 * Saves the selected workspace auth info for a given user.
 */
export const STORAGE_WORKSPACE_INFO = "@flowls/workspace_info";

export const STORAGE_CHUNK_RELOAD_FLAG = "@flowls/chunk_reload_attempted";

export enum ChunkReloadStatus {
  PENDING = "pending",
  DONE = "reloaded",
}
